module.exports = __webpack_public_path__ + "static/media/naranja.4d8b7371.svg";